import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { useAudiencesCRUDActions } from '@mm/state/actions/AudiencesCRUDActions';

export const useFetchAudience = (
  audienceId: number | undefined,
  params?: {
    handleError?: boolean;
    options?: { skipBusy?: boolean };
    queryParams?: { inUse: boolean };
  },
) => {
  const [busy, setBusy] = useState(false);
  const activeChatbotId = useSelector(activeChatbotIdSelector);
  const { retrieveAudienceById } = useAudiencesCRUDActions();

  const fetchAudience = async () => {
    setBusy(true);
    if (audienceId && activeChatbotId) {
      await retrieveAudienceById(
        activeChatbotId,
        audienceId,
        params?.handleError,
        params?.options,
        params?.queryParams,
      );
    }
    setBusy(false);
  };

  useEffect(() => {
    fetchAudience();
  }, [activeChatbotId, audienceId]);

  return { busy };
};
